import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import RequestReducer, {
  defaultState,
  asyncActions,
  syncActions,
} from 'src/ducks/request.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(RequestReducer, defaultState, {
    ...asyncActions,
    ...syncActions,
  });
};

type IRequestContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const RequestContext = createContext<Partial<IRequestContext>>({
  state: defaultState,
}) as React.Context<IRequestContext>;

const RequestProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <RequestContext.Provider value={{ ...reducer }}>
      {children}
    </RequestContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useRequestContext = () => useContext(RequestContext);

export type IUseRequestContext = ReturnType<typeof useRequestContext>;

export { RequestContext, RequestProvider };
